import React from 'react';
import { motion } from 'framer-motion';
import { BatteryWarning, Brain, Activity } from 'lucide-react';
export function ProblemSection() {
  const cards = [{
    icon: <BatteryWarning className="w-8 h-8 text-brand-gold mb-4" data-id="element-113" />,
    title: 'Cansancio diario',
    text: 'Para personas que buscan acompañar su energía y vitalidad durante el día.'
  }, {
    icon: <Brain className="w-8 h-8 text-brand-gold mb-4" data-id="element-114" />,
    title: 'Falta de enfoque',
    text: 'Una alternativa natural para quienes quieren apoyar concentración y claridad mental.'
  }, {
    icon: <Activity className="w-8 h-8 text-brand-gold mb-4" data-id="element-115" />,
    title: 'Estrés y ritmo acelerado',
    text: 'Una forma simple de integrar una rutina de bienestar más consciente.'
  }];
  return <section className="py-20 bg-brand-cream" id="beneficios" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-118">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-heading font-bold text-brand-green mb-6" data-id="element-119">
            Cuando tu rutina exige más equilibrio, tu bienestar también necesita
            apoyo
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg text-brand-brown/80" data-id="element-120">
            El ritmo diario, el cansancio, la falta de enfoque y el estrés
            cotidiano pueden hacer que muchas personas busquen alternativas
            naturales para complementar su bienestar. Los extractos de hongos
            funcionales se han vuelto una opción cada vez más valorada por
            quienes quieren cuidar su energía, claridad y equilibrio de forma
            simple.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-121">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-beige hover:shadow-md transition-shadow" data-id="element-122">
              {card.icon}
              <h3 className="text-xl font-heading font-bold text-brand-green mb-3" data-id="element-123">
                {card.title}
              </h3>
              <p className="text-brand-brown/70 leading-relaxed" data-id="element-124">{card.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}